// import script accordingly
import "./themes/pages/_autoload";
import "./themes/utils/_autoload";
